<template>
    <div class="page knowledge-detail">

        <knowledge-detail-skeleton v-if="loading" style="margin-bottom: 100vh"></knowledge-detail-skeleton>

        <div class="tags" style="margin-top: 30px">
            <van-tabs :swipeable="true" v-model="category_index" @change="changeCategory">
                <van-tab :title-class="'course-list-category-title'" v-for="(item,index) in knowledge.knowledge_part" :key="index" :title="item.title" ></van-tab>
            </van-tabs>
            <div class="clear"></div>
        </div>

        <div class="knowledge-detail-box">
            <div class="clear" style="margin-top: 15px"></div>
            <div>
                <div class="knowledge-detail-content">
                    <div class="rich_media_inner" v-html="content"></div>
                </div>
            </div>
        </div>
    </div>

</template>

<script>
    import Interface from "@/util/interface"
    import knowledgeDetailSkeleton from "@/skeleton/articleDetailSkeleton"
    export default {
        name: 'knowledge-detail',
        components :{
            'knowledge-detail-skeleton' : knowledgeDetailSkeleton
        },
        data() {
            return {
                id:0,
                value: "",
                active: "",
                category_id :0,
                category_child_id:0,
                banners: [],
                categories: [],
                categories_child:[],
                recommend:[],
                list:[],
                column:[],
                knowledge:{},
                comment:[],
                comment_text:"",
                loading:true,
                share_data :{},
                showShareDialog:false,
                htmlUrl:"",
                isShow:false,
                status:"",
                comment_id :0,
                to_user_id:0,
                comment_placeholder:"写评论",
                user_id:0,
                content:"",
                part_id:0,
            }
        },
        methods: {
            fetch(scene) {
                if (scene === 'knowledge') {
                    Interface.getData('get', Interface.knowledge.detail+this.id).then((res) => {
                        this.knowledge = res.data
                        //this.content = this.knowledge.knowledge_part[this.category_index].content
                        this.changeCategory()
                        setTimeout(()=>{this.loading = false;},500)
                        if(this.knowledge){
                            Interface.getShareInfo(this,this.knowledge.title,this.knowledge.cover_img,this.knowledge.desc)
                        }
                    })
                }else if (scene === 'part') {
                    let params = {
                        id : this.id,
                        part_id : this.part_id,
                    }
                    Interface.getData('get', Interface.knowledge.part,params).then((res) => {
                        this.content = res.data.content
                    })
                } else if (scene === 'comment') {
                    let params = {
                        content_id:this.id,
                        comment_type:2,
                        page:1,
                        pageSize:999
                    }
                    Interface.getData('get', Interface.comment,params).then((res) => {
                        if(res.code == 0){
                            if(res.data.list)
                                this.comment = res.data.list
                        }
                    })
                }else if (scene === 'footprint') {
                    let params = {
                        id : this.id,
                        type:9,
                    }
                    Interface.getData('post', Interface.footprint,params).then((res) => {

                    })
                }
            },
            changeCategory(){
                this.part_id = this.knowledge.knowledge_part[this.category_index].id
                this.fetch('part')
            },
        },
        created() {
            this.id = this.$route.params.id
            this.category_index = this.$route.query.part
            this.fetch('knowledge')
            this.fetch('footprint')
        },
    }
</script>

<style lang="scss">
    @import "./index";
    @import "../../../components/comment";
</style>



// WEBPACK FOOTER //
// src/views/knowledge/detail/index.vue